<template>
  <div class="card-area">
    <form novalidate class="md-layout" @submit.prevent="validateUser">
      <md-card class="md-layout-item md-size-50 md-small-size-100">
        <div class="md-title">Secure ID Verify</div>

        <md-card-header>
          <div class="md-title">How does it work?</div>
        </md-card-header>
        <div class="md-title">
          The purpose of SecureIDVerfiy is to securely and independently verify
          your age and identification details.
          <br />
          You capture some images of your ID with this app and we then issue you
          with a special ID code (SVID) that you can use on websites and apps
          that need to verify your ID.
          <br />
          Your identification documents are kept securely on our servers and not
          shared with third parties.
          <br />
          Verifying your ID with us only takes 5 minutes!
        </div>
        <md-card-actions>
          <md-button class="md-primary" @click="Gophoto">Ok!</md-button>
        </md-card-actions>
      </md-card>
    </form>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";

export default {
  name: "ResendCode",
  props: {
    msg: String,
  },
  component: {},
  mixins: [validationMixin],
  data: () => ({
    form: {
      sixcode: null,
    },
  }),

  mounted() {},
  methods: {
    Gophoto() {
      this.$router.push({ name: "Login" });
    },
    saveUser() {},
  },
};
</script>

<style lang="css" scoped>
/* .md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}

.md-card-actions {
  flex-direction: column;
}

.md-card-actions .md-button {
  margin-top: 20px !important;
  padding: 10px;
}
.footer {
  margin-top: 20px;
  padding: 10px;
  font-size: 120%;
}

.md-card {
  display: inline-block;
  padding: 20px;
}

.card-area {
  align-items: center;
  justify-content: center;
  background: #ddd;
    width: 180vw !important;
}

.md-primary {
  background-color: green;
  color: white !important;
}

.md-layout-item.md-size-50 {
  min-width: 25%;
  max-width: 25%;
} */
</style>
